const ERRORS = {
  USER_NOT_FOUND: '找不到用戶',
  UNAUTHORIZED: '未授權',
  INVALID_OLD_PASSWORD: '舊密碼錯誤',
  NEW_CONFIRMED_PASSWORD_NOT_MATCH: '新密碼與確認新密碼不相同',
  INVALID_USER_PASSWORD: '商戶或管理員密碼錯誤',
};

export const getErrorMsg = (code, errors = {}) => {
  const msg = errors ? { ...ERRORS, ...errors }[code] : ERRORS[code];
  if (!msg) return '發生錯誤，請重新再試';
  return msg;
};

export default {};
